import {Graphics, Sprite, InteractionEvent} from 'pixi.js';
import {DrawColor} from './DrawColor';
import {HoverableObject} from '../../../../../base/HoverableObject';
import {DrawInstrumentMenuData} from '../../draw_buttons/DrawInstrumentMenuData';

export class ColorButton extends HoverableObject
{
    private back: Graphics;
    private line: Graphics;
    private size: number = 32;

    constructor(public drawColor: DrawColor, private onClick: (drawColor: DrawColor) => void) {
        super();

        this.back = new Graphics();
        this.back.beginFill(this.drawColor);
        this.back.drawRoundedRect(-this.size / 2, -this.size / 2, this.size, this.size, 5);
        this.back.endFill();

        this.line = new Graphics();

        this.addChild(this.back);
        this.addChild(this.line);
    }

    private _selected: boolean = false;

    get selected(): boolean {
        return this._selected;
    }

    set selected(value: boolean) {
        this._selected = value;

        this.line.clear();
        if (!value) {
            return;
        }
        //this.line.lineStyle(2, 0xc4c4c4);
        this.line.lineStyle(3, 0xf65a00);
        this.line.moveTo(-this.size / 2 + 5, -this.size / 2 - 6);
        this.line.lineTo(this.size / 2 - 5, -this.size / 2 - 6);
    }

    onPointerDown(e: InteractionEvent): void {
        super.onPointerDown(e);
        this.onClick(this.drawColor);
    }
}
